import { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  Button,
  Paper,
  TextField,
  Stack,
  List,
  ListItem,
  ListItemText,
  IconButton,
  CircularProgress,
  Alert,
} from "@mui/material";
import { Delete as DeleteIcon, ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useItems, useCreateItem, useDeleteItem } from "../queries/useItems";

/**
 * Página de EJEMPLO (vertical slice): demuestra el patrón
 * página → React Query hooks → service → axios → API DRF.
 * Bórrala al modelar el dominio real.
 */
export default function Items() {
  const navigate = useNavigate();
  const { data: items, isLoading, isError } = useItems();
  const createItem = useCreateItem();
  const deleteItem = useDeleteItem();
  const [nombre, setNombre] = useState("");

  const handleCreate = (e: React.FormEvent) => {
    e.preventDefault();
    if (!nombre.trim()) return;
    createItem.mutate({ nombre: nombre.trim() }, { onSuccess: () => setNombre("") });
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <AppBar position="static" elevation={1}>
        <Toolbar>
          <IconButton color="inherit" edge="start" onClick={() => navigate("/app")} sx={{ mr: 1 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Items (ejemplo)
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm" sx={{ py: 4 }}>
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <form onSubmit={handleCreate}>
            <Stack direction="row" spacing={2}>
              <TextField
                fullWidth
                size="small"
                label="Nombre del item"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                disabled={createItem.isPending}
              />
              <Button type="submit" variant="contained" disabled={createItem.isPending || !nombre.trim()}>
                Crear
              </Button>
            </Stack>
          </form>
        </Paper>

        <Paper elevation={2} sx={{ p: 2 }}>
          {isLoading && (
            <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
              <CircularProgress />
            </Box>
          )}
          {isError && <Alert severity="error">No se pudieron cargar los items.</Alert>}
          {items && items.length === 0 && (
            <Typography color="text.secondary" sx={{ p: 2 }}>
              No hay items todavía. Crea el primero arriba.
            </Typography>
          )}
          {items && items.length > 0 && (
            <List>
              {items.map((item) => (
                <ListItem
                  key={item.id}
                  secondaryAction={
                    <IconButton edge="end" aria-label="eliminar" onClick={() => deleteItem.mutate(item.id)}>
                      <DeleteIcon />
                    </IconButton>
                  }
                >
                  <ListItemText primary={item.nombre} secondary={`#${item.id} · ${item.creado_por}`} />
                </ListItem>
              ))}
            </List>
          )}
        </Paper>
      </Container>
    </Box>
  );
}
